export enum GadgetsTimePeriod {
  Week = 'Week',
  Month = 'Month',
  Quarter = 'Quarter',
  HalfYear = '6 Months',
  Year = 'Year',
}
